// filepath: apps/web/src/renderers/form/fields/HiddenField.tsx
//
// Renders nothing — used by FR-FORM-4 server-evaluated visibility output.
// The renderer still emits the value via onChange; UI shows no input.
//
// INV-2: this is a cosmetic hide — the server has already stripped any
// truly unauthorized fields. Renderer-side hiding is never a security
// boundary.

import React from "react";
import type { FieldComponentProps } from "../FieldRegistry";

export function HiddenField(
  _props: FieldComponentProps,
): React.ReactElement | null {
  // No DOM output. The field is tracked via the renderer's internal
  // record but the user never sees it.
  return null;
}
